import {HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse} from '@angular/common/http';
import {inject} from '@angular/core';
import {Dispatcher} from '@ngrx/signals/events';
import {CountryIdentifiedEvent} from '@scalified-monorepo/ng-shared/ngrx';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

export const COUNTRY_HEADER = 'cf-country';

export function countryInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // injection context
  const dispatcher = inject(Dispatcher);
  return next(req).pipe(
    tap(event => {
      if (req.url.includes('assets/i18n/') && event instanceof HttpResponse) {
        //let country = 'ua';
        const country = event.headers.get(COUNTRY_HEADER);
        if (country) {
          // not injection context
          dispatcher.dispatch(CountryIdentifiedEvent({countryCode: country.toLowerCase()}));
        }
      }
    })
  );
}
